import { useMemo } from 'react';
import { useQuery } from 'react-query';
import firebase from '../config/firebase.config';
import { getTeamMemberDetails } from '../services/teamMemberDetails';
import { queryKeys } from '../config/queryKeys';

const database = firebase.firestore();

const ROSTER_STALE_MS = 2 * 60 * 1000;

/**
 * Team roster from teamDatabase memberDetails only (fast path).
 * Shares cache key with useTeamMemberDetails for the same teamId.
 *
 * @param {string | null | undefined} teamId
 */
export function useEmployeeListRoster(teamId) {
  const {
    data: memberDetailsMap = {},
    isLoading,
    isError,
    error,
    refetch,
  } = useQuery({
    queryKey: queryKeys.teamMemberDetails.detail(teamId),
    queryFn: () => getTeamMemberDetails(database, teamId),
    enabled: Boolean(teamId),
    staleTime: ROSTER_STALE_MS,
  });

  const employees = useMemo(() => {
    const entries = Object.entries(memberDetailsMap || {}).filter(
      ([, d]) => d && d.deleted !== true
    );
    return entries
      .map(([userId, d]) => ({
        userId,
        name: d.userName || 'N/A',
        email: d.userEmailid || 'N/A',
        role: d.userType || 'N/A',
      }))
      .sort((a, b) =>
        (a.name || '').localeCompare(b.name || '', undefined, {
          sensitivity: 'base',
        })
      );
  }, [memberDetailsMap]);

  return {
    employees,
    memberDetailsMap,
    isLoading,
    isError,
    error: error || null,
    refetch,
  };
}
